import { useContext } from "react";
import { CallTrackingContext } from "../provider";
export const useCallTracking = () => {
    const context = useContext(CallTrackingContext);
    if (context === null) {
        throw new Error("useCallTracking must be used within a CallTrackingContext provider");
    }
    return context;
};
